// extracted by mini-css-extract-plugin
module.exports = {"confirm-button":"styles-module__confirm-button___2Q_rd","footer":"styles-module__footer___33ksl"};